import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './Gifted.scss';

const Gifted: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      className={s['root']}
      gap={2}
    >
      <GiftIcon disableDefaultColors size={IconSize.TINY} />
      {t('sidebar.exclusives.currentOwner.gifted')}
    </Flex>
  );
};
Gifted.displayName = 'Gifted';

export default Gifted;
